import logo from './images/logo/logo.png';
import useIsMobile from './index';
import {Link} from 'react-router-dom';
import { useState } from "react";

const menuItems = [
  { name: "Galerie", path: "/galerie" },
  { name: "Nos Fournisseurs", path: "/fournisseurs" },
  { name: "Nos Clients", path: "/clients" },
  { name: "Matériels", path: "/materiels" },
  { name: "Nous contacter", path: "/contact" },
];

function Header() {
    const isMobile = useIsMobile();
    const [menuOpen, setMenuOpen] = useState(false);

    const handleLinkClick = () => {
      setMenuOpen(false); // ferme le menu quand on clique sur un lien
    };

    return (
      <header className="App-header">
        <Link to="/" className='Header-logo'>
            <img src={logo} className="Logo" alt="logo" />
            <p className='Header-logo-txt'> Son - Lumière </p>
        </Link>

        {isMobile && (
          <div className="Hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </div>
        )}

        <div className={`Menu-Header ${menuOpen ? "open" : ""}`}>
          {menuItems.map((item) => (
            <Link key={item.name} to={item.path} className='Item-Menu' onClick={handleLinkClick}>
              {item.name}
            </Link>
          ))}
        </div>
      </header>
  );
}

export default Header;